import { render } from "./PageUpdateHasilPenilaian.vue?vue&type=template&id=73d70ebf"
import script from "./PageUpdateHasilPenilaian.vue?vue&type=script&lang=js"
export * from "./PageUpdateHasilPenilaian.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__